<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="cashback_absolute_offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? cashbackItems : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? minMaxItems : cashbackItems">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="minMaxItems">
        <user-consumption :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'CashbackAbsoluteOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.cashback_absolute_offer_sales && this.offerSale.cashback_absolute_offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.cashback_absolute_offer_sales.reduce((acc, cashbackOfferSale) => acc + cashbackOfferSale.user_sale_consumption_amount, 0)
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    cashbackItems() {
      return [
        {
          label: 'Preço 1',
          value: this.offerSale.price,
          format: 'currency',
        },
        {
          label: 'Cashback (R$)',
          value: this.offerSale.cashback_absolute,
          format: 'currency',
        },
      ]
    },
    minMaxItems() {
      return [
        {
          label: 'Mín. CPF',
          value: this.offerSale.minimum_per_client,
          format: 'text',
        },
        {
          label: 'Máx. CPF',
          value: this.offerSale.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>
